// 首尾不能为空格，中间可以为空格的字符串
export const Required = /^\S.*\S$|(^\S{0,1}\S$)/;

// 数字或小数
export const numbers = /^[0-9]{1}([0-9]|[.])*$/;

// 手机验证
// export const phone = /^[1-9][0-9]{9}$/
export const phone = /^1\d{10}$/;
export const phpphone = /^9\d{9}$/;

// 由6-16位英文或数字组成
export const name = /^[a-zA-Z0-9]{6,16}$/;

// 数字或字母，中间只能有一个空格
export const realName = /^[a-zA-Z]\s{0,1}([\w]{1,}\s{1})*\w{1,}$/;

// 字母特殊字符
export const realName828 = /^[a-zA-Z,._!@#$%^&* ]{4,30}$/;

// 由6-12位英文或数字,数字加字母组成
export const numOrletter = /^[A-Za-z0-9]{6,12}$/;

// 由6-12位英文或数字,数字加字母组成
export const numOrletterGOA = /^[A-Za-z0-9]{6,20}$/;

// 由6-12位英文或数字,数字加字母加特殊字符组成
export const numOrletter800 = /^[0-9a-zA-Z,._!@#$%^&*]{6,20}$/;

// 由不少于6位英文或数字,数字加字母组成  817
export const numOrletter817 = /^[A-Za-z0-9]{6,}$/;
// 由1-16位英文或数字,数字加字母组成 858不限制账号长度
export const numOrletter825 = /^[A-Za-z0-9]{1,15}$/;

export const numOrletterLogin825 = /^.{1,15}$/;
// 由1-16位英文或数字,数字加字母组成 858不限制账号长度
export const numOrletter858 = /^[A-Za-z0-9]{1,16}$/;

// 由4-16位英文或数字,数字加字母组成
export const numOrletter2 = /^[A-Za-z0-9]{4,16}$/;

// 账号由6-12位组成，需包含英文、数字并且字母开头
export const name2 = /^(?=^.*?\d)(?=^.*?[a-zA-Z])^[0-9a-zA-Z]{6,12}$/;

// 由6-12位大小写英文字母、0-9和部分特殊符号组成
export const pwd = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{6,12}$/;

// 由8-20位大小写英文字母、0-9和部分特殊符号组成
export const pwd824 = /^[0-9a-zA-Z,._!@#$%^&*]{4,20}$/;

export const vrifyCode = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{4}$/;

export const vrifyCode2 = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{4,6}$/;

//不为空
export const agentCode = /\S/;
export const smsVrifyCode = /\S/;
export const mailVrifyCode = /\S/;

// 邮箱格式
// export const email = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
// export const email = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
// export const email = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
// export const email = /^\w+(?:\.\w+){0,1}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,4}){1,2}$/
export const email =
  /[^`~!@#$%\^&\*\(\)\+=\|\{\}\':;\',\\\[\]\.<>\/\?~！@#￥%……&\*（）——+\|\{\}【】‘；：”“’。，、？\s]{1,}@[^`~!@#$%\^&\*\(\)\+=\|\{\}\':;\',\\\[\]\.<>\/\?~！@#￥%……&\*（）——+\|\{\}【】‘；：”“’。，、？\s]{1,}\.[^`~!@#$%\^&\*\(\)\+=\|\{\}\':;\',\\\[\]<>\/\?~！@#￥%……&\*（）——+\|\{\}【】‘；：”“’。，、？\s]{1,}/;

// 6到22位银行卡号 /^([1-9]{1})(\d{5}|\d{21})$/
export const bank = /^[0-9]\d{5,21}$/;

// 大于0正整数
export const integer1 = /^\+?[1-9]\d*$/;
// 小数
export const integer2 = /^[0-9]+([.]{1}[0-9]+){0,1}$/;

// 验证qq
export const checkQQ = /^[1-9][0-9]{4,11}$/;

// 验证微信 5-20个字母、数字、下划线或减号，以字母开头
export const checkWechat = /^[a-zA-Z][a-zA-Z\d_-]{4,19}$/;

export const checkTelegram = /\S/;
export const checkWhatsapp = /\S/;

// 验证提款密码
export const checkDrawPwd = /^[A-Za-z0-9]{4,1000}$/;

// 验证提款密码支持特殊符号 824
export const checkDrawPwd824 = /^[0-9a-zA-Z!@#%$*&^.~_)(}{|;:=+<>]{4,1000}$/;

export const checkName = (val) => {
  let pass = true;
  if (val === "") {
    pass = false;
  } else {
    if (!name2.test(val)) pass = false;
  }
  return pass;
};

export const checkPwd = (val) => {
  let pass = true;
  if (val === "") {
    pass = false;
  } else {
    if (!pwd.test(val)) pass = false;
  }
  return pass;
};

export const ValidateRequire = (val) => {
  return val && val.length > 0 && val.trim() !== "";
};
export const ValidateReallyName = (val) => {
  // let reg = /^[^0-9]{6,}$/
  // return val && reg.test(val.trim()) && val.trim() !== ''
  return /^[a-zA-Z\u4E00-\u9FA5\·]{2,10}$/.test(val.trim());
};

// 验证手机号 必填
export const validataPhone = function (val) {
  if (val === "") {
    return false;
  } else {
    return phone.test(val);
  }
};
// 验证菲律宾手机号 必填
export const validataPhpPhone = function (val) {
  if (val === "") {
    return false;
  } else {
    return phpphone.test(val);
  }
};
// 验证手机号 非必填
export const checkPhone = function (val) {
  let pass = true;
  if (val !== "" && !phone.test(val)) pass = false;
  return pass;
};

export const validataQQ = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!checkQQ.test(val)) pass = false;
  } else {
    if (val !== "" && !checkQQ.test(val)) pass = false;
  }
  return pass;
};

export const validataWhatsapp = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!checkWhatsapp.test(val)) pass = false;
  } else {
    if (val !== "" && !checkWhatsapp.test(val)) pass = false;
  }
  return pass;
};

export const validataTelegram = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!checkTelegram.test(val)) pass = false;
  } else {
    if (val !== "" && !checkTelegram.test(val)) pass = false;
  }
  return pass;
};

export const validataWechat = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!checkWechat.test(val)) pass = false;
  } else {
    if (val !== "" && !checkWechat.test(val)) pass = false;
  }
  return pass;
};

export const validataEmail = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!email.test(val)) pass = false;
  } else {
    if (val !== "" && !email.test(val)) pass = false;
  }
  return pass;
};

export const validataFirstname = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!realName.test(val)) pass = false;
  } else {
    if (val !== "" && !realName.test(val)) pass = false;
  }
  return pass;
};

export const validataMiddlename = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!realName.test(val)) pass = false;
  } else {
    if (val !== "" && !realName.test(val)) pass = false;
  }
  return pass;
};

export const validataLastname = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!realName.test(val)) pass = false;
  } else {
    if (val !== "" && !realName.test(val)) pass = false;
  }
  return pass;
};
// 账号密码验证  字母、数字或字母数字组合
export const checkOne = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!numOrletter.test(val)) pass = false;
  } else {
    if (val !== "" && !numOrletter.test(val)) pass = false;
  }
  return pass;
};
// 账号密码验证2  字母、数字或字母数字组合
export const checkOne02 = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!numOrletter817.test(val)) pass = false;
  } else {
    if (val !== "" && !numOrletter817.test(val)) pass = false;
  }
  return pass;
};

// 账号密码验证  字母、数字或字母数字组合
export const checkOne3 = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!pwd824.test(val)) pass = false;
  } else {
    if (val !== "" && !pwd824.test(val)) pass = false;
  }
  return pass;
};
// 账号密码验证  字母、数字或字母数字组合
export const checkOne4 = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!numOrletter2.test(val)) pass = false;
  } else {
    if (val !== "" && !numOrletter2.test(val)) pass = false;
  }
  return pass;
};

// 账号密码验证  字母、数字或字母数字组合
export const checkOne5 = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!numOrletter800.test(val)) pass = false;
  } else {
    if (val !== "" && !numOrletter800.test(val)) pass = false;
  }
  return pass;
};

// 验证码
export const checkVrifyCode = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (val.length !== 4) pass = false;
  } else {
    if (val !== "" && val.length !== 4) pass = false;
  }
  return pass;
};

// 整数数字
export const validataNumber = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!integer1.test(val)) pass = false;
  } else {
    if (val !== "" && !integer1.test(val)) pass = false;
  }
  return pass;
};
// 整数数字
export const validataNumber2 = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!integer2.test(val)) pass = false;
  } else {
    if (val !== "" && !integer2.test(val)) pass = false;
  }
  return pass;
};

// 验证银行卡号
export const validataBank = (val, type) => {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!bank.test(val)) pass = false;
  } else {
    if (val !== "" && !bank.test(val)) pass = false;
  }
  return pass;
};

// 提款密码
export const validataDrawPwd = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!checkDrawPwd.test(val)) pass = false;
  } else {
    if (val !== "" && !checkDrawPwd.test(val)) pass = false;
  }
  return pass;
};

// 提款密码
export const validataDrawPwd818 = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
  }
  return pass;
};
// 提款密码
export const validataDrawPwd824 = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!checkDrawPwd824.test(val)) pass = false;
  } else {
    if (val !== "" && !checkDrawPwd824.test(val)) pass = false;
  }
  return pass;
};
// 实名认证
export const validataRealName = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!realName.test(val)) pass = false;
  } else {
    if (val !== "" && !realName.test(val)) pass = false;
  }
  return pass;
};

// 实名认证
export const validataRealName828 = function (val, type) {
  let pass = true;
  let req = type === undefined ? true : type; // 是否必填
  if (req) {
    if (val === "") pass = false;
    if (!realName828.test(val)) pass = false;
  } else {
    if (val !== "" && !realName828.test(val)) pass = false;
  }
  return pass;
};
export function validatebankPay(that) {
  return {
    caccountid: [{ required: true, message: "Required", trigger: "change" }],
    // amount: [
    // 	{ required: true, message:'Required', trigger: 'change' },
    // ],
    depositname: [{ required: true, message: "Required", trigger: "change" }],
    Transferfrom: [{ required: true, message: "Required", trigger: "change" }],
    remarks: [{ required: true, message: "Required", trigger: "change" }],
    depositimage: [{ required: true, message: "Required", trigger: "change" }],
  };
}

export function validatePay(that) {
  return {
    amount: [{ required: true, message: "Required", trigger: "change" }],
  };
}



// WEBPACK FOOTER //
// ./src/common/utils/validate.js